import React from 'react';
import Layout from './Components/Layout/Layout';
import {StyleRoot}from 'radium';


function App() {
  return (
    <StyleRoot>
      <Layout/>
    </StyleRoot>
  );
}

export default App;
